import React from 'react'
import {useReportsModalContext} from 'modules/reports/components/Modal/ReportsModal.context'
import {Typography} from '@material-ui/core'
// import useStyles from './ReportsModalTitle.styles'

type Props = {
  children: React.ReactNode
}

function ReportsModalTitle(props: Props) {
  // const classes = useStyles()
  const context = useReportsModalContext()

  return (
    <Typography id={`${context.id}-title`} variant="h5" component="h2">
      {props.children}
    </Typography>
  )
}

export default ReportsModalTitle
